// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b26adb4c","239":"7c153267","453":"1a966992","732":"1fd9d660"}[chunkId] + ".chunk.js";
};